import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "bg-gray-50 p-4 my-2 rounded"
};
const _hoisted_2 = {
  class: "grid grid-cols-2 gap-2 mb-2"
};
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import GroundSlotComponent from "@/modules/club-grounds/components/GroundSlot.vue";
import { GroundSlot } from "@/modules/club-grounds/entity";
import { app } from "@/di";
import AggregatedEffectProvider from "@/modules/club-grounds/services/AggregatedEffectProvider";
import Effects from "@/modules/club-grounds/components/slot-types/Effects.vue";
import { EventEmitter } from "@/modules/base/events";
import { Team } from "@/modules/team/entity";
import AfterCurrencyChangeEvent from "@/modules/action-points/ events/AfterCurrencyChangeEvent";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  async setup(__props) {
    let __temp, __restore;
    const groundSlots = ref();
    const aggregatedEffects = ref();
    const team = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      team.value = await Team.current();
      groundSlots.value = await GroundSlot.find();
      aggregatedEffects.value = app.get(AggregatedEffectProvider).get(groundSlots.value.filter(slot => slot.type && !slot.developedAt));
    })), __temp = await __temp, __restore(), __temp);
    onUnmounted(app.get(EventEmitter).onOff([AfterCurrencyChangeEvent], refresh));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('club_grounds')), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(Effects, {
          effects: aggregatedEffects.value
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aggregated_effects')), 1)]),
          _: 1
        }, 8, ["effects"])]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groundSlots.value, groundSlot => {
          return _openBlock(), _createBlock(GroundSlotComponent, {
            key: groundSlot.id,
            "ground-slot": groundSlot,
            team: team.value,
            onUpdate: _unref(refresh)
          }, null, 8, ["ground-slot", "team", "onUpdate"]);
        }), 128))])]),
        _: 1
      });
    };
  }
});